import { differenceInCalendarDays, format, getYear } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import type { PaidRestPeriod } from '@/features/Collaborators/Models/collaborator';
import { createDateSafe } from '@/utils/dateUtils';

export const MODAL_TITLE = 'Histórico de Descanso Remunerado';
export const MODAL_CANCEL_LABEL = 'Fechar';
export const EMPTY_MESSAGE = 'Nenhum descanso lançado para este PJ.';
export const EMPTY_HINT = 'Edite o cadastro do PJ para lançar períodos de descanso.';

export function formatPeriodWithDays(startDate: string, endDate: string): {
    formatted: string;
    days: number;
} {
    const start = createDateSafe(startDate);
    const end = createDateSafe(endDate);

    if (!start || !end) {
        return { formatted: '—', days: 0 };
    }

    const days = differenceInCalendarDays(end, start) + 1;
    const formatted = `${format(start, 'dd/MMM', { locale: ptBR })} a ${format(end, 'dd/MMM', { locale: ptBR })}`;

    return { formatted, days };
}

export function groupPeriodsByYear(periods: PaidRestPeriod[]): Map<number, PaidRestPeriod[]> {
    const grouped = new Map<number, PaidRestPeriod[]>();

    // Sort por data decrescente (mais recente primeiro)
    const sorted = [...periods].sort((a, b) => {
        const dateA = createDateSafe(a.startDate);
        const dateB = createDateSafe(b.startDate);
        if (!dateA || !dateB) return 0;
        return dateB.getTime() - dateA.getTime();
    });

    sorted.forEach((period) => {
        const year = getYear(createDateSafe(period.startDate) || new Date());
        if (!grouped.has(year)) {
            grouped.set(year, []);
        }
        grouped.get(year)?.push(period);
    });

    return grouped;
}

export function calculateYearTotal(periods: PaidRestPeriod[], year: number): number {
    return periods.reduce((sum, period) => {
        const start = createDateSafe(period.startDate);
        if (!start || getYear(start) !== year) return sum;

        const end = createDateSafe(period.endDate);
        if (!end) return sum;

        const days = differenceInCalendarDays(end, start) + 1;
        return sum + days;
    }, 0);
}

export function calculateTotalDays(periods: PaidRestPeriod[]): number {
    return periods.reduce((sum, period) => {
        const start = createDateSafe(period.startDate);
        const end = createDateSafe(period.endDate);
        if (!start || !end) return sum;

        const days = differenceInCalendarDays(end, start) + 1;
        return sum + days;
    }, 0);
}
